// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RIi--TimeInputSelect--width_static{width:var(--uikit-size-xl)}.v54--TimeInputSelect--listSelect{max-height:calc(var(--uikit-size-m) * 6)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"themeBase": "TimeInputSelect",
	"width_static": "RIi--TimeInputSelect--width_static",
	"listSelect": "v54--TimeInputSelect--listSelect"
};
module.exports = ___CSS_LOADER_EXPORT___;
